import { getWatermarkedImgixUrl } from "services";
import { TestimonialsSliderComponent } from "./TestimonialsSliderComponent";
import { SectionContainerBase } from "@reusejs/react";

export default function TestimonialsComponent() {
  const testimonials = [
    {
      name: "Anshul Saxena",
      designation: "Advisor - Product | Strategy | Growth | Entrepreneurship",
      testimonial:
        "Happy to associate with Auction Bazaar. The team is very hard-working, enthusiastic, and proactive. The user-friendly platform experience is an adorable feature. I would strongly recommend everyone to check it out!!!",
      imageUrl: getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/2c5089d4-8407-4509-9eed-d57129202cda?fill=fit&auto=format`,
      ),
    },
    {
      name: "Manish Arora",
      designation:
        "CEO-Karat Solutions LLP Seasoned Banker with 26 Years of Experience",
      testimonial:
        "I like the team approach; how they solve the problem. They are ethical and transparent in showcasing all the pictures, videos, and anything/everything related to auction properties. The value-added services (Consulting, financing) provided by them are appreciable. Even a person with little knowledge about the auction process can easily pass through and acquire a property.",
      imageUrl: getWatermarkedImgixUrl(
        `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/ad1ae0c3-bc46-46a6-94ff-98159f98e09f?fill=fit&auto=format`,
      ),
    },
  ];

  const List = [
    <div
      className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
      key="testimonial-1"
    >
      <div className="relative">
        <blockquote className="mt-10">
          <div className="max-w-3xl mx-auto text-center text-base md:text-2xl leading-6 md:leading-9 font-semibold text-white">
            <p>&ldquo;{testimonials[0].testimonial}&rdquo;</p>
          </div>
          <footer className="mt-8">
            <div className="md:flex md:items-center md:justify-center">
              <div className="md:flex-shrink-0">
                <img
                  className="mx-auto h-10 w-10 rounded-full"
                  src={testimonials[0].imageUrl}
                  alt=""
                />
              </div>
              <div className="mt-3 text-center md:mt-0 md:ml-4 md:flex md:items-center">
                <div className="text-base font-medium text-white">
                  {testimonials[0].name}
                </div>

                <svg
                  className="hidden md:block mx-1 h-5 w-5 text-white"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M11 0h3L9 20H6l5-20z" />
                </svg>

                <div className="text-base font-medium text-gray-500">
                  {testimonials[0].designation}
                </div>
              </div>
            </div>
          </footer>
        </blockquote>
      </div>
    </div>,
    <div
      className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
      key="testimonial-2"
    >
      <div className="relative">
        <blockquote className="mt-10">
          <div className="max-w-3xl mx-auto text-center text-base md:text-2xl leading-6 md:leading-9 font-semibold text-white">
            <p>&ldquo;{testimonials[1].testimonial}&rdquo;</p>
          </div>
          <footer className="mt-8">
            <div className="md:flex md:items-center md:justify-center">
              <div className="md:flex-shrink-0">
                <img
                  className="mx-auto h-10 w-10 rounded-full"
                  src={testimonials[1].imageUrl}
                  alt=""
                />
              </div>
              <div className="mt-3 text-center md:mt-0 md:ml-4 md:flex md:items-center">
                <div className="text-base font-medium text-white">
                  {testimonials[1].name}
                </div>

                <svg
                  className="hidden md:block mx-1 h-5 w-5 text-white"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M11 0h3L9 20H6l5-20z" />
                </svg>

                <div className="text-base font-medium text-gray-500">
                  {testimonials[1].designation}
                </div>
              </div>
            </div>
          </footer>
        </blockquote>
      </div>
    </div>,
  ];

  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-20 bg-slate-900 overflow-hidden",
        innerContainerStyles: "w-full",
      }}
    >
      <h3 className="text-2xl md:text-4xl w-full flex justify-center text-white font-extrabold tracking-tight">
        Testimonials
      </h3>
      <TestimonialsSliderComponent elements={List} />
    </SectionContainerBase>
  );
}
